import { FEATURE_LIMIT } from '@/api/apiModules'
import TableUtils from '@/utils/tableUtils'
export default {
  viewType: 'table',
  module: FEATURE_LIMIT,
  sortArr: [
    {
      fieldName: 'createTime',
      direction: 'DESC'
    }
  ],
  refreshInterval: 120000,
  params: {},
  extraParams: {},
  allowStatus: {},
  cb() {
    let isChannel = this.$store.getters.baseInfo.channel
    if (isChannel) {
      TableUtils.deleteColumnByDataType(this.view.columns, 'operation')
      TableUtils.deleteColumnByProp(this.view.columns, 'limitDesc')
      TableUtils.deleteColumnByProp(this.view.columns, 'competitiveList')
      this.view.menus = []
    } else {
      TableUtils.setColumnByProp(this.view.columns, 'schemeDesign', 'width', '240')
    }
  },
  toolbar: {
    searchWidth: 300,
    searchPlaceholder: '功能名',
    searchFieldNameArr: ['featureName'],
    tips: {
      label: '注：可以查询功能对应的限制说明，也可以针对某个功能添加限制说明，限制说明来源于售前、售后或管理员所提供',
      type: 'warning'
    },
    items: []
  },
  class: 'sk-custom-table-right-page',
  view: {
    'cell-class-name': 'sk-customize-cell-hight',
    columns: [
      {
        props: {
          label: '功能名',
          prop: 'featureName',
          width: 240
        }
      },
      {
        props: {
          label: '测试说明',
          prop: 'schemeDesign'
        }
      },
      {
        props: {
          label: '业务诉求【主打价值】',
          prop: 'valueDesc',
          width: 240
        }
      },
      {
        props: {
          label: '版本支持',
          prop: 'productId',
          width: 200
        },
        dataType: 'custom',
        custom(row, _h, value, e) {
          return row.productVersion
        },
        filter: true,
        filterName: 'productId',
        url: `feature/listProduct`
      },
      {
        props: {
          label: '限制说明',
          prop: 'limitDesc',
          width: 260
        }
      },
      {
        props: {
          label: '竞争力信息',
          prop: 'competitiveList',
          width: 360
        },
        dataType: 'custom',
        custom: function(data, h) {
          if (!data || !data.competitiveList || data.competitiveList.length == 0) {
            return
          }
          const renderItem = []
          data.competitiveList.forEach(el => {
            renderItem.push(
              <div class="wsp-margin-left-3 wsp-margin-top-3">
                <div class="wsp-custom-content-break">
                  【友商：{el.competitorCn}】
                  <el-tag
                    type={
                      el.competitiveness === '优势'
                        ? 'success'
                        : el.competitiveness === '劣势'
                        ? 'danger'
                        : el.competitiveness === '持平'
                        ? 'primary'
                        : 'warning'
                    }
                  >
                    {el.competitiveness}
                  </el-tag>
                  &nbsp;&nbsp;{el.competitiveComparison}
                </div>
              </div>
            )
          })
          return renderItem
        }
      },
      {
        props: {
          label: '有用',
          prop: 'likeNum',
          width: 70
        }
      },
      {
        props: {
          label: '无用',
          prop: 'dislikeNum',
          width: 70
        }
      },
      {
        props: {
          label: '创建时间',
          prop: 'createTime',
          sortField: 'createTime',
          width: 160
        },
        dataType: 'date'
      },
      {
        props: {
          showBtnNum: '1',
          fixed: null
        },
        dataType: 'operation'
      }
    ],
    menus: [
      {
        icon: 'el-icon-edit',
        label: '限制反馈',
        command: 'FeatureLimitCreate',
        name: 'FeatureLimitCreate',
        tip: '暂无权限反馈'
      }
    ]
  }
}
